import { corporbankUrl, corporbankUrlBackUp } from '@/config/constants'

export const changeVersionByDomain = function () {
  const reg = /cbibank\.com$/
  // 兼容两套域名 因为cbibank.com域名在某些网络下被屏蔽
  /*
    由于中国移动内部故障，使用中国移动网络访问我行企业网银和官网目前无法访问
    临时解决方案为：
    https://online.cbibank.com 跳转至 https://ebank.cbibank.com/corporbank
    https://online.cbibservice.com 跳转至 https://ebank.cbibservice.com/corporbank
  */
  if (reg.test(window.location.hostname)) {
    window.open(corporbankUrl)
  } else {
    window.open(corporbankUrlBackUp)
  }
}
